const listeners = {};

export function subscribe(event, cb) {
  listeners[event] = listeners[event] || [];
  listeners[event].push(cb);
  return () => {
    listeners[event] = listeners[event].filter((fn) => fn !== cb);
  };
}

export function publish(event, data) {
  (listeners[event] || []).forEach((fn) => {
    try {
      fn(data);
    } catch (e) {
      console.error('eventBus handler error', e);
    }
  });
}

const eventBus = { subscribe, publish };
export default eventBus;
